<div class="container" *ngIf="!isResponsive">
  <div *ngFor="let step of steps" class="step" [ngClass]="step.status">
    <button class="btn" [disabled]="step.status == 'pending' || step.status == 'current'" >
      <ion-icon name="checkmark"></ion-icon>
    </button>

    <div class="title">
      <p>{{ step.title }}</p>
      <p class="subtitle">{{ step.subTitle }}</p>

      <div class="nav" *ngIf="step?.nav_index">
        <p class="subtitle">{{ step.stepInfo }}</p>
        <p class="underline" *ngFor="let index of step?.nav_index">
          <a href="{{ step?.url }}#{{ index?.id }}">
            {{ index?.name }}
          </a>
        </p>
      </div>
    </div>
  </div>

</div>
<div class="container" *ngIf="isResponsive">
  <ion-accordion-group>
    <ion-accordion value="first">
      <ion-item slot="header" class="item-current-step">
        <div class="header-content">
          <ion-label><span class="currentStepResponsive">{{ currentStepResponsive }}</span> - {{ titleCurrentStepResponsive }}</ion-label>
          <ion-progress-bar [value]="calculateProgress()"></ion-progress-bar>
        </div>
      </ion-item>

      <div class="ion-padding" slot="content">
        <div *ngFor="let step of steps; let i = index" class="step" [ngClass]="step.status">
          <button class="btn" [disabled]="step.status == 'pending' || step.status == 'current'"
            [routerLink]="[step.path]">
            <ion-icon name="checkmark"></ion-icon>
          </button>
          <div class="title" [ngClass]="{'pending-title': step.status === 'pending'}">
            <p>Paso {{ i + 1 }}</p>
            <p class="subtitle">{{ step.subTitle }}</p>
          </div>
        </div>
      </div>
    </ion-accordion>
  </ion-accordion-group>
</div>